import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChevronDownDDS } from "../../../asset";

const ArrLincense = [
  { value: "SIM A", id: 1 },
  { value: "SIM B1", id: 2 },
  { value: "SIM B2", id: 3 },
  { value: "SIM C", id: 4 },
  { value: "SIM D", id: 5 },
];

const DropdownListLicenseType = ({
  setValueDDS,
  children,
  valueDDS,
  className,
  togglerClassName,
  placeholder,
  ...attrs
}) => {
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [dataSelected, setDataSelected] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const onClickDataSelected = useCallback(
    (data) => {
      setDataSelected(data);
      setIsShowDropdownContent(false);
      setValueDDS(data?.id);
    },
    [setValueDDS]
  );

  useEffect(() => {
    if (!valueDDS) {
      setDataSelected();
      return;
    }
    if (valueDDS) {
      const dataSelected = ArrLincense.filter((el) => el.id === valueDDS);

      setDataSelected(dataSelected[0]);
      // setValueDDS(valueDDS);
    }
    return;
  }, [valueDDS]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="w-full border border-gray-200 bg-white-100 flex justify-between px-[6px] rounded-md h-[40px] items-center"
        onClick={togglerDropdownContent}
      >
        <span
          className={"font-roboto text-xl text-black-300 font-medium px-2 truncate".concat(
            !dataSelected ? " text-opacity-50" : ""
          )}
        >
          {dataSelected ? dataSelected.value : placeholder}
        </span>
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div></div>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? " active mt-5" : ""
        )}
        ref={dropdownContentRef}
      >
        <ul className="overflow-auto max-h-[300px]">
          {ArrLincense.map((el, index) => (
            <li
              key={index}
              className="dropdown-item truncate"
              onClick={() => {
                onClickDataSelected(el);
              }}
            >
              {el.value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DropdownListLicenseType;
